import classNames from "classnames";

export interface MainProps {
  children?: React.ReactNode;
  className?: string;
}

export const Main = ({ children, className = "", ...rest }: MainProps) => (
  <main
    className={classNames(
      "bg-secondary grid-in-main size-full overflow-auto p-8",
      className,
    )}
    {...rest}
  >
    {children}
  </main>
);
